import React from 'react';
import { aboutText } from '../data/mockData';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { ChefHat, Heart, Truck } from 'lucide-react';

export const AboutSection = () => {
  const iconMap = {
    chef: ChefHat,
    halal: Heart,
    delivery: Truck
  };

  return (
    <section id="about" className="py-24 bg-[#1A1A1A]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2
            className="text-5xl md:text-6xl font-bold text-[#D4A85F] mb-4"
            style={{ fontFamily: "'Crimson Text', 'Times New Roman', serif" }}
          >
            {aboutText.title}
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            Découvrez notre passion pour la cuisine authentique
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {aboutText.cards.map((card, index) => {
            const IconComponent = iconMap[card.icon];
            return (
              <Card
                key={index}
                className="bg-gradient-to-br from-[#2A2A2A] to-[#1A1A1A] border-2 border-[#D4A85F]/30 hover:border-[#D4A85F] transition-all duration-300 hover:shadow-xl hover:shadow-[#D4A85F]/20 group"
              >
                <CardHeader>
                  <div className="flex justify-center mb-4">
                    <div className="bg-[#D4A85F] p-4 rounded-full group-hover:scale-110 transition-transform duration-300">
                      <IconComponent className="text-black w-8 h-8" />
                    </div>
                  </div>
                  <CardTitle className="text-center text-[#D4A85F] text-xl">
                    {card.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-gray-400 text-center leading-relaxed">
                    {card.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
